module.exports = __webpack_public_path__ + "public-ui/fonts/greek-ext.71fe14c5.woff2";